module.exports = __webpack_public_path__ + "img/tutorial_guideChat_01.d41796d0.jpg";